import { compiledPaths } from '@app/paths';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { isDefined } from '@app/utils/is';
import React from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from '../various/Tooltip';

interface Props {
  id: string;
  name?: string;
}

export const LookbookNameColumn = ({ id, name }: Props) => {
  const ref = React.useRef<HTMLAnchorElement>(null);
  const path = compiledPaths.LOOKBOOK_SINGLE({ lookbookId: id });
  const isOverflowing = useIsOverflowing(ref, { widthOnly: true });

  if (!isDefined(name)) {
    return;
  }

  return (
    <Tooltip content={isOverflowing && name}>
      <Link to={path} ref={ref} className="z-interactiveTableItem max-w-60 truncate" tabIndex={-1}>
        {name}
      </Link>
    </Tooltip>
  );
};
